import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { calculators } from "@/data/calculatorsData";

export default function RelatedCalculators({ currentSlug }) {
  const others = calculators.filter(c => c.slug !== currentSlug);

  return (
    <section className="py-16 sm:py-20 bg-[#F5F5F2] border-t border-[#383A46]/10" data-testid="related-calculators">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <h2 className="font-heading font-semibold text-2xl sm:text-3xl text-[#21324D] tracking-tight mb-8">
          More Free Calculators
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {others.map((calc) => (
            <Link
              key={calc.slug}
              to={`/calculators/${calc.slug}`}
              className="group bg-white border border-[#383A46]/10 p-6 hover:border-[#A7A55C]/40 transition-all duration-300"
              data-testid={`related-calc-${calc.slug}`}
            >
              <div className="flex items-center gap-2 mb-3">
                <calc.icon size={16} weight="duotone" className="text-[#A7A55C]" />
                <h3 className="font-body font-medium text-sm text-[#21324D] group-hover:text-[#A7A55C] transition-colors">
                  {calc.shortTitle}
                </h3>
              </div>
              <p className="font-body text-xs text-[#383A46]/60 leading-relaxed mb-4 line-clamp-2">
                {calc.shortDesc}
              </p>
              <span className="flex items-center gap-1 font-body text-xs font-semibold text-[#A7A55C]">
                Try it <ArrowRight size={12} weight="bold" className="group-hover:translate-x-1 transition-transform" />
              </span>
            </Link>
          ))}
        </div>
        <div className="mt-8 text-center">
          <Link to="/tools" className="font-body text-sm text-[#A7A55C] hover:text-[#8C8A4A] transition-colors inline-flex items-center gap-2">
            View all free calculators <ArrowRight size={14} weight="bold" />
          </Link>
        </div>
      </div>
    </section>
  );
}
